import React from 'react';
import InterestChip from './InterestChip';

const InterestWindow = props => {
    return (
        <div className="interest-window">
            {props.interests.map(interest => {
                return <InterestChip key={interest} value={interest} clicked={() => props.clicked(interest)} />
            })}
        </div>
    )
}

export default InterestWindow;